export class ThingActivation {
    public locationId: string;
    public serialNumber: string;
    public connectionToken: string;
    public gpsPosition: string
}